import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import CseCreatePage from './cse-create'
import { CseListPage } from './cse-list'
import CseUpdatePage from './cse-update'

export const cseRoutes: Route[] = [
  {
    path: Paths.CSE_LIST_PAGE,
    element: <CseListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CSE_CREATE_PAGE,
    element: <CseCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.CSE_UPDATE_PAGE,
    element: <CseUpdatePage />,
    roles: [RoleEnum.ADMIN]
  }
]
